/* eslint-disable max-len */
import * as ActionTypes from '../components/actions/types';

const initialState = {
  currentEvent: '',
  insAuthorized: false
};

function socialMediaReducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.SOCAILMEDIA_SET_EVENTSLUG:
      return {
        ...state,
        currentEvent: action.payload
      };
    case ActionTypes.AUTH_SOCIALMEDIA_STATUS:
      return {
        ...state,
        insAuthorized: true
      };
    case ActionTypes.UNAUTH_SOCIALMEDIA_STATUS:
      return {
        ...state,
        insAuthorized: false
      };
    case ActionTypes.SOCAILMEDIA_RESET:
      return { ...initialState };
    default: {
      return state;
    }
  }
}

export default socialMediaReducer;




// WEBPACK FOOTER //
// ./src/reducers/socialMedia.js